import { computed, defineComponent, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppNavigation from '@/components/AppNavigation/AppNavigation.vue'
import FeedbackPopup from '@/components/FeedbackPopup/FeedbackPopup.vue'
import { useLockBodyScroll } from '@/composables/useLockBodyScroll'
import { useAuthStore } from '@/store/auth'
import { useMainStore } from '@/store/main'

export default defineComponent({
  name: 'AppHeader',
  components: { AppNavigation, FeedbackPopup },
  setup() {
    const authStore = useAuthStore()
    const mainsStore = useMainStore()
    const route = useRoute()
    const isOpenMenu = ref(false)
    const isHome = computed(() => route.name === 'home')
    const { enableBodyScroll, disableBodyScroll } = useLockBodyScroll()

    const toggleMenu = () => {
      isOpenMenu.value = !isOpenMenu.value
      if (isOpenMenu.value) {
        disableBodyScroll()
      }
      else {
        enableBodyScroll()
      }
    }
    watch(() => route.name, () => {
      isOpenMenu.value = false
      enableBodyScroll()
    })
    return {
      mainsStore,
      isHome,
      isOpenMenu,
      toggleMenu,
      authStore,
    }
  },
})
